var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('navigation-tabs', _vm._l(_vm.visibleMenuList, function (v, i) {
    return _c('router-link', {
      key: i,
      attrs: {
        "to": {
          name: v.pathName
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(v.name)) + " ")]);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }